import cogoToast from 'cogo-toast';
import React, { useState } from 'react';
import { Button, Col, Input, Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from 'reactstrap';
import { desembolsoServices } from '../../services';

const MAXIMO = 500;

/** Edita solo la observación que imprime la hoja contable; el resto del desembolso no se toca. */
const ObservacionesModal = ({ desembolso, onCancel, onSaved }) => {
    const [texto, setTexto] = useState(desembolso.observaciones || '');
    const [guardando, setGuardando] = useState(false);

    const guardar = async () => {
        setGuardando(true);
        const response = await desembolsoServices.updateObservaciones(desembolso.desembolso, texto);
        setGuardando(false);

        if (!response || response.error) {
            cogoToast.error(response?.msg || 'No se logró guardar las observaciones',
                { position: 'bottom-left', heading: 'Error', hideAfter: 6 });
            return;
        }

        cogoToast.success('Observaciones actualizadas', { position: 'bottom-right' });
        onSaved(texto);
    };

    return (
        <Modal size="lg" isOpen toggle={onCancel}>
            <ModalHeader toggle={onCancel} tag="div">
                <h5>Observaciones de la hoja contable</h5>
                <span className="text-primary" style={{ fontSize: '0.8em' }}>
                    {`Crédito ${desembolso.credito} · ${desembolso.cliente}`}
                </span>
            </ModalHeader>
            <ModalBody className="p-3">
                <Input
                    type="textarea"
                    id="observacionesHojaContable"
                    rows={8}
                    maxLength={MAXIMO}
                    value={texto}
                    onChange={(e) => setTexto(e.target.value)}
                />
                <small className="text-muted">{`${texto.length}/${MAXIMO} caracteres`}</small>
            </ModalBody>
            <ModalFooter className="no-border">
                <Col className="text-right">
                    <Button onClick={onCancel} color="falcon-default" className="mr-2" disabled={guardando}>
                        Cancelar
                    </Button>
                    <Button onClick={guardar} color="primary" disabled={guardando}>
                        {guardando ? <Spinner size="sm" color="light" /> : 'Guardar'}
                    </Button>
                </Col>
            </ModalFooter>
        </Modal>
    );
};

export default ObservacionesModal;
